import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import arkIcon from '../../../theme/assets/other/tc_cab_apostol_ark_icon.png';
import lockIcon from '../../../theme/assets/svg/tc_cab_capsule_lock_icon.svg';

// разряды по три — как в макете: 900.000 / 1.000.000
const countHandler = (value) => {
    return String(Number(value) || 0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

const CabinetMainArks = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const dashboard = useSelector(store => store.cabinet.dashboard);

    const periods = dashboard?.periods || [];

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    <div className={`${Styles.cardTitle}`}>{t('Наполняемость ковчегов')}</div>

                    <div className={`${Styles.arksWrap}`}>
                        {periods.length ? periods.map((period)=>{
                            const total = period?.capsules_count || 0;
                            const taken = period?.taken || 0;
                            const percent = total ? Math.round((taken * 100) / total) : 0;
                            // ковчег считается открытым, если он активен или в нём уже есть капсулы
                            const isOpen = period?.is_active || taken > 0;

                            return (
                                <div className={`${Styles.arkRow}`} key={'cabinet-ark_' + period?.number}>
                                    <div className={`${Styles.arkIconWrap} ${!isOpen ? Styles.arkIconWrapLocked : ''}`}>
                                        <img src={isOpen ? arkIcon : lockIcon} alt=""/>
                                    </div>

                                    <div className={`${Styles.arkPos}`}>
                                        <div className={`${Styles.arkTop}`}>
                                            <span className={`${Styles.arkName}`}>{t('Ковчег')} {period?.number}</span>
                                            <span className={`${Styles.arkPercent}`}>{percent}%</span>
                                        </div>
                                        <div className={`${Styles.arkBar}`}>
                                            <div className={`${Styles.arkFill}`} style={{width: `${percent}%`}}/>
                                        </div>
                                        <div className={`${Styles.arkMeta} ${!isOpen ? Styles.arkMetaLocked : ''}`}>
                                            {isOpen
                                                ? `${countHandler(taken)} / ${countHandler(total)}`
                                                : t('Скоро откроется')}
                                        </div>
                                    </div>
                                </div>
                            );
                        }) : (
                            <div className={`${Styles.emptyNote}`}>{t('Данных пока нет')}</div>
                        )}
                    </div>

                    <div
                        className={`${Styles.cardBtn}`}
                        onClick={()=>{navigate('/cabinet/apostol')}}
                    >
                        {t('Подробнее')}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetMainArks;
